export default __webpack_public_path__ + "static/media/telefono.e43ceaa7.svg";